import { Box, Container, Title, Text, Divider, Flex } from "@mantine/core";
import React from "react";

interface TitleComponentProps {
  title?: string;
  description?: string;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
}

export const TitleComponent: React.FC<TitleComponentProps> = ({ title, description, leftSection, rightSection }) => {
  const isCompact = !title && !description;

  if (isCompact) {
    return (
      <>
        <Box py="sm" px="md">
          <Container fluid>
            <Flex justify={leftSection ? "space-between" : "flex-end"} align="center">
              {leftSection && <Box>{leftSection}</Box>}
              {rightSection && <Box>{rightSection}</Box>}
            </Flex>
          </Container>
        </Box>
        <Divider mb="xs" />
      </>
    );
  }

  return (
    <>
      {/* Mobile Header */}
      <Box p="md" hiddenFrom="sm">
        <Container fluid>
          <Flex justify="space-between" align="center" mb={4}>
            <Flex align="center" gap="sm">
              {leftSection && <Box>{leftSection}</Box>}
              <Box>
                <Title order={2} fz={20} fw={400}>
                  {title}
                </Title>
              </Box>
            </Flex>
            {rightSection && <Box>{rightSection}</Box>}
          </Flex>
        </Container>
      </Box>

      {/* Desktop Header */}
      <Box visibleFrom="sm" pt={20} p="md">
        <Container fluid>
          <Flex justify="space-between" align="center">
            <Flex align="center" gap="sm">
              {leftSection && <Box>{leftSection}</Box>}
              <Box>
                <Title order={2} fz={24} fw={400} mb={4}>
                  {title}
                </Title>
                {description && (
                  <Text size="sm" c="slate.7">
                    {description}
                  </Text>
                )}
              </Box>
            </Flex>
            {rightSection && <Box>{rightSection}</Box>}
          </Flex>
        </Container>
      </Box>
      {/* Full-width divider */}
      <Divider mb={{ base: "md", sm: "md" }} />
    </>
  );
};

export default TitleComponent;
